export default "__VITE_ASSET__Dks3Y$jz__"